import React from "react";
import HomeRepairLoginForm from "components/design-system/organisms/HomeRepairLoginForm";
import useHomeRepairAuth from "hooks/useHomeRepairAuth";
import Loading from "components/HomeRepairFunnelV2/Components/Loading";

const Bouncer: React.FunctionComponent = ({ children }) => {
  const { loading, authenticated } = useHomeRepairAuth();
  if (loading) {
    return <Loading />;
  }
  if (!authenticated) {
    return <HomeRepairLoginForm />;
  }

  return <>{children}</>;
};

export default Bouncer;
